import { get } from 'lodash';
import { graphqlRequest } from '../urql';

import { sectionMapping, sectionMappingToApi } from '@/common/mapping';

import { SectionBase } from '@/common/models';

import {
  addSectionMutation,
  updateSectionMutation,
  deleteSectionMutation,
  updateSectionOrderMutation,
  deleteSectionTagMutation,
  updateSectionTagMutation
} from './mutations';
import { isOk } from '@/common/utils';

/**
 * Add new section, and update the last section order
 *
 * @param   {String}  bookId  id of selected book
 * @param   {Object}  section data of new section
 * @param   {String}  lastSetionId id of the last section
 * @param   {Object}  lastSectionParams params of the last section
 * @returns {Object}          mutation result
 */
export const addNewSectionApi = async (
  bookId,
  section,
  lastSectionId,
  lastSectionParams
) =>
  graphqlRequest(addSectionMutation, {
    bookId,
    params: sectionMappingToApi(section),
    lastSectionId,
    lastSectionParams: sectionMappingToApi(lastSectionParams)
  });

/**
 * Update section
 *
 * @param   {String}  sectionId id of selected section
 * @param   {Object}  params    new data of selected section
 * @returns                     mutation result
 */
export const updateSectionApi = async (sectionId, params) => {
  const res = await graphqlRequest(updateSectionMutation, {
    sectionId,
    params: sectionMappingToApi(params)
  });

  return new SectionBase({ ...sectionMapping(res.data) });
};

/**
 * Update order of  sections
 *
 * @param   {String}  bookId      id of current bok
 * @param   {Array}   sectionIds  new order of sections
 * @returns {Object}              mutation result
 */
export const updateSectionOrderApi = async (bookId, sectionIds) => {
  const res = await graphqlRequest(updateSectionOrderMutation, {
    bookId,
    sectionIds: sectionIds.map(id => parseInt(id))
  });

  return isOk(res);
};

/**
 * Delete a section
 *
 * @param   {String}  sectionId id of selected section
 * @param   {String}  bookId id of selected book
 * @param   {Array<Int>}  sectionId id of sections in book
 * @returns {Object}            mutation result
 */
export const deleteSectionApi = async (sectionId, bookId, sectionIds) => {
  const res = await graphqlRequest(deleteSectionMutation, {
    sectionId,
    bookId,
    sectionIds
  });

  return isOk(res);
};

export const deleteSectionTagApi = async (sectionId, tagIds) => {
  const res = await graphqlRequest(deleteSectionTagMutation, {
    sectionId,
    tagIds
  });

  return isOk(res);
};

export const updateSectionTagApi = async (sectionId, params) => {
  const res = await graphqlRequest(updateSectionTagMutation, {
    sectionId,
    params: sectionMappingToApi(params)
  });
  if (!isOk(res)) return [];
  const tags = get(res, 'data.update_book_section.tags', []);
  return tags;
};
